module.exports = __webpack_public_path__ + "img/calendar-heart-02.13fe12dd.svg";